import api from "../../lib/api";

export default {
  namespaced: true,
  state: {
    list: [],
    isAddOrEdit: false,
    posting: false,
    loading: true,
    url: {
      id: 0,
      url: "",
      request_method: "", // GET POST PUT PATCH DELETE
      request_type: "" // STATUS PING AUTH CREDIT BALANCE
    }
  },
  mutations: {
    setUrls(state, payload) {
      state.list = payload;
    },
    resetUrl(state) {
      state.url = {
        id: 0,
        url: "",
        request_method: "",
        request_type: ""
      };
    },
    resetUrls(state) {
      state.list = [];
    },
    setIsAddOrEdit(state, payload) {
      if (!payload)
        state.url = { id: 0, url: "", request_method: "", request_type: "" };
      state.isAddOrEdit = payload;
    },
    setPosting(state, payload) {
      state.posting = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setUrl(state, payload) {
      state.url = payload;
    }
  },
  actions: {
    async getUrls({ commit }, site_id) {
      commit("setLoading", true);
      try {
        let { data } = await api.get(`/sites/${site_id}/urls`);
        commit("setUrls", data);
        commit("setLoading", false);
      } catch (error) {
        commit("setLoading", false);
      }
    },
    async saveUrl({ commit, dispatch, state }, site_id) {
      commit("setPosting", true);
      if (state.url.id) await dispatch("updateUrl", site_id);
      else await dispatch("addUrl", site_id);
    },
    editUrl({ commit, state }, url_id) {
      commit(
        "setUrl",
        state.list.find(url => url.id === url_id)
      );
      commit("setIsAddOrEdit", true);
    },
    async addUrl({ commit, dispatch, state }, site_id) {
      try {
        await api.post(`/sites/${site_id}/urls`, { url: state.url });
        await dispatch("getUrls", site_id);
        commit("resetUrl");
        commit("setIsAddOrEdit", false);
        commit("setPosting", false);
      } catch (error) {
        commit("setPosting", false);
      }
    },
    async updateUrl({ commit, state, dispatch }, site_id) {
      try {
        await api.put(`/sites/${site_id}/urls/${state.url.id}`, {
          url: state.url
        });
        await dispatch("getUrls", site_id);
        commit("resetUrl");
        commit("setIsAddOrEdit", false);
        commit("setPosting", false);
      } catch (error) {
        commit("setPosting", false);
      }
    },
    async deleteUrl({ dispatch }, { site_id, url_id }) {
      await api.delete(`/sites/${site_id}/urls/${url_id}`);
      dispatch("getUrls", site_id);
    }
  },
  getters: {
    urls: state => state.list,
    url: state => state.url,
    isAddOrEdit: state => state.isAddOrEdit,
    posting: state => state.posting,
    loading: state => state.loading
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/urls.js